/**
 * Extracts a user-facing message from API client errors (e.g. `HttpError` with JSON `body`).
 */
export function getApiErrorMessage(err: unknown): string {
  if (typeof err === "string" && err.length > 0) {
    return err;
  }

  if (err && typeof err === "object" && "body" in err) {
    const body = (err as { body: string }).body;
    if (typeof body === "string" && body.length > 0) {
      try {
        const parsed = JSON.parse(body) as { message?: string; error?: string };
        const msg = parsed.message ?? parsed.error;
        if (typeof msg === "string" && msg) {
          return msg;
        }
      } catch {
        return body;
      }
    }
  }
  if (err instanceof Error) {
    return err.message;
  }

  return "Unknown error";
}
